import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { formsSelectors } from 'Modules'
import { FormNames } from 'Constants/FormNames'
import { useAppDispatch } from 'Src/hooks'
import { FieldNames } from 'Constants/FieldNames'
import {
	BtnComponent,
	FormNotificationComponent,
	Heading,
	Indent,
	RadioComponent,
	UITypes,
} from 'LibNeo'
import { bgLeadSlice, GrayCaption, Lead, RequestType } from 'Pages/ibro'
import { BlockButtons } from 'LibNeo/components/Basic/Buttons/Button/styled'
import { Callback } from 'Types/utilTypes'

interface ComponentProps {
	openModalAgreement: Callback
	close: Callback
	requestType?: RequestType
	itemSelector: Callback<unknown, Lead>
	changeOptions: { is_director: boolean }
	isSigner?: boolean
}

const actions = {
	changeLeadBg: bgLeadSlice.actions.changeLeadBg,
}

export const GovLeadModal = ({
	openModalAgreement,
	close,
	requestType,
	itemSelector,
	changeOptions,
	isSigner,
}: ComponentProps) => {
	const [leadId, setLeadId] = useState(0)
	const item = useSelector(itemSelector)
	const form = useSelector(
		formsSelectors.getGlobalFormMemoized(FormNames.BROKER.REQUEST.CLIENT_INFO)
	)
	const { changeLeadBg } = useAppDispatch(actions)
	const { is_director } = changeOptions

	const currentLeadId = form
		? item.active_leads?.find((lead) => {
				if (is_director) {
					return lead.fio === form.getFieldValue(FieldNames.FIO_DIRECTOR)
				}
				return lead.fio === form.getFieldValue(FieldNames.FIO)
		  })?.id
		: item.active_leads?.find((lead) => lead.fio === item.fio)?.id
	useEffect(() => {
		if (currentLeadId) setLeadId(currentLeadId)
	}, [currentLeadId])

	const changeLeadOptions = [
		{
			value: 0,
			key: '0',
			label: isSigner ? 'Добавить доверенное лицо' : 'Добавить руководителя (ЕИО)',
		},
	]
	item.active_leads?.forEach((lead) => {
		if (isSigner === lead.attorney) {
			changeLeadOptions.push({
				value: lead.id,
				key: String(lead.id),
				label: lead.fio,
			})
		}
	})
	const applyLead = () => {
		if (!leadId) {
			close()
			openModalAgreement()
		} else if (currentLeadId === leadId) {
			close()
		} else {
			changeLeadBg({ id: item.id, lead_id: leadId, requestType, changeOptions })
		}
	}

	const modalHeading = isSigner ? 'Доверенное лицо' : 'Руководитель организации'

	return (
		<>
			<Heading type="subtitle1">{modalHeading}</Heading>
			<GrayCaption>
				Вы можете добавить данные о новом лице или выбрать из ранее указанных.
			</GrayCaption>

			<Indent top={32} bottom={32}>
				<RadioComponent
					options={changeLeadOptions}
					value={leadId}
					onChange={setLeadId as (v: number) => void}
				/>
			</Indent>
			{!leadId && (
				<Indent bottom={32}>
					<FormNotificationComponent
						hideIcon
						type={UITypes.WARNING}
						message="Необходимо получить согласие на обработку персональных
								данных для указания сведений о новом руководителе"
					/>
				</Indent>
			)}
			<BlockButtons>
				<BtnComponent title="Применить" onClick={applyLead} />
				<BtnComponent title="Отмена" type={UITypes.PASSIVE} onClick={close} />
			</BlockButtons>
		</>
	)
}
